// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3WPl-","name":"Header_name__QA7km","birthday":"Header_birthday__dF2aE","skeleton":"Header_skeleton__6lYgN"};